module.exports = __webpack_public_path__ + "static/media/sprites_2x.97064722.png";